import { CalculatePriceRequest } from "@/models/api/CalculatePriceRequest";
import { CalculatePriceResponse } from "@/models/api/CalculatePriceResponse";
import { BookingSummary } from "@/models/www/store/BookingSummary";
import baseApi from "./api.service";

const calculateService = {
	calculatePrice(calculatePriceRequest: CalculatePriceRequest): Promise<BookingSummary> {
		return new Promise((resolve, reject) => {
			baseApi.post<CalculatePriceResponse>("calc", calculatePriceRequest)
				.then(resp => resolve(new BookingSummary(resp)))
				.catch(err => reject(err))
		})
	}
}

export default calculateService;